import NewSearchBtn from './NewSearchBtn';

export default NewSearchBtn;
export { NewSearchBtn };
